import React from 'react';
import '../css/Features.css';
import parabenFree from '../assets/images/paraben-free.png';
import sulphateFree from '../assets/images/sulphate-free.png';
import crueltyFree from '../assets/images/cruelty-free.png';
import non from '../assets/images/non-carc.png';
import siliconFree from '../assets/images/silicon-free.png';

function Features() {
  const features = [
    { img: parabenFree, label: 'Paraben Free' },
    { img: sulphateFree, label: 'Sulphate Free' },
    { img: crueltyFree, label: 'Cruelty Free' },
    { img: non, label: '100% Vegan' },
    { img: siliconFree, label: 'Silicon Free' },
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        {features.map((item, idx) => (
          <div className="feature-card" key={idx}>
            <img src={item.img} alt={item.label} />
            <p>{item.label}</p>
          </div>
        ))}
      </div>
      <div className="intro-container">
    <h2 className="intro-title">Gitaami – Crafted With Soul, Rooted In Nature
   </h2>
    <p className="intro-text">
    <strong>Welcome to Gitaami – a celebration of self-love, tradition, and timeless beauty.</strong>
    We’re more than just a brand. We’re a movement — one that believes in conscious choices, honest ingredients, and everyday rituals that make you feel something real.
    </p>
  </div>
    </section>
    
  );
}

export default Features;
